//=================================================
//    summary: DCP LUAssign 視窗 -- Hook
//
//    remarks: 000 Tim 2021/11/08 Create
//             001 Tim 2021/12/06 改成 Popup顯示
//             002 Tim 2021/12/23 Fix Bug lesson列表有問題（有好幾個lesson1)
//                                加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssLUAssign from './LUAssign.module.scss'
import './LUAssign.css'
import ChooseAssignment from './ChooseAssignment/ChooseAssignment'
import TextField from '@material-ui/core/TextField'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

import {LoadingMask, AlertWindow, GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region State Member Variables
let mstrStateMessage = ""
let mstrStateStartDate = ""
let mstrStateDueDate = ""
let mintStateClassIndex = 0
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false
let mobjCallParam = null
let mstrBookSeqNo = ""
let mobjChooseAssignment = null
let marrClassMemberData = []
let marrStudentListData = []
let marrClass = []
let mintCurrentClassIndex = -1
// #endregion Member Variables

// #region Const
const MAX_MESSAGE_CHARACHERS = 300 // Textarea最大的數字限制
// #endregion Const


const COMP_NAME = "LUAssign"

function LUAssign(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateChooseAssignmentTime, setUpdateChooseAssignmentTime] = useState(0)
    const [updateStudentDataTime, setUpdateStudentDataTime] = useState(0)

    const [anchorEl4Class, setAnchorEl4Class] = useState(null)
    const [message, setMessage] = useState("")
    const [startDate, setStartDate] = useState("")
    const [dueDate, setDueDate] = useState("")
    const [classIndex, setClassIndex] = useState(-1)
    const [isSelectAll, setIsSelectAll] = useState(false)

    const [isShowChooseAssignment, setIsShowChooseAssignment] = useState(false)
    
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    // #endregion Init State

    // #region Init Ref
    let mrefClassDropdown = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefGetClassMemberDataList = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefGetClassMemberDataList.current = GetClassMemberDataList
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mstrBookSeqNo = window.gSession.App.BookSeqNo.toString().PadLeft(2)
        mintStateClassIndex = -1
        marrClass = []
        mintCurrentClassIndex = -1

        let datStart = new Date()
        let strStartDate = datStart.FormateBCDisplayDate()
        setStartDate(strStartDate)

        // 取得 7 天後的日期
        let intRange = 7
        let datDue = new Date()
        datDue.setDate(datDue.getDate() + intRange)
        let strDueDate = datDue.FormateBCDisplayDate()
        setDueDate(strDueDate)

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)        
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update message
    useEffect(() => {
        mstrStateMessage = message
    }, [message])

    // Update startDate
    useEffect(() => {
        mstrStateStartDate = startDate
    }, [startDate])

    // Update dueDate
    useEffect(() => {
        mstrStateDueDate = dueDate
    }, [dueDate])

    // Update classIndex
    useEffect(() => {
        if (classIndex >= 0)
        {
            mintStateClassIndex = classIndex
            mobjCallParam = {
                "ClassID": marrClass[classIndex].ClassID,
                "DataType": 1
            }
            mrefGetClassMemberDataList.current()
        }
    }, [classIndex])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()
        
        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
            mstrBookSeqNo = ""
            mobjChooseAssignment = null
            marrClassMemberData = []
            marrStudentListData = []
            marrClass = []
            mintCurrentClassIndex = -1
        }
    }, [])


    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        if (
            (typeof(props.LessonID) !== 'undefined') && 
            (props.LessonID !== null) &&
            (parseInt(props.LessonID) > 0)
            )
        {
            let intLessonIndex = 0
            let intSectionType = -1
            let intLUCatSeqNo = 1
            let strMenuName = ""
            let strSectionName = ""

            console.log(COMP_NAME + ".componentDidMount: props.LessonID: ", props.LessonID)

            intLessonIndex = GetLessonIndex(props.LessonID)

            if (    
                (typeof(props.SectionName) !== 'undefined') && 
                (props.SectionName !== null) &&
                (props.SectionName !== '')
                )
            {
                strSectionName = props.SectionName
                if (props.SectionName === window.gAppUI.LBL_Practice)
                {
                    intSectionType = 1
                }
                else if (props.SectionName === window.gAppUI.LBL_Review)
                {
                    intSectionType = 2
                }
            }

            if (    
                (typeof(props.MenuName) !== 'undefined') && 
                (props.MenuName !== null) &&
                (props.MenuName !== '')
                )
            {
                strMenuName = props.MenuName
            }

            if (    
                (typeof(props.LUCatSeqNo) !== 'undefined') && 
                (props.LUCatSeqNo !== null) &&
                (parseInt(props.LUCatSeqNo) > 0)
                )
            {
                intLUCatSeqNo = parseInt(props.LUCatSeqNo)
            }                

            mobjChooseAssignment = {
                "LessonIndex": intLessonIndex,
                "LUCatSeqNo": intLUCatSeqNo,
                "LUName": strMenuName,
                "SectionName": strSectionName,
                "SectionType": intSectionType
            }

            setUpdateChooseAssignmentTime(new Date().getTime())
        } // end of if (props.LessonID !== null)

        InitClassList()
    } // end of PaintedMe
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 點選 返回 按鈕
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function BackOnTapHandler()
    {
        console.log(COMP_NAME +  ".BackOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objCallbackData = {
            "Action": "CloseShowLUAssign",
            "IsUpdate": false
        }
        props.CallbackRef(objCallbackData)
    } // end of BackOnTapHandler

    /*===========================================
    summary: 點選 選擇單元 按鈕
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ChooseAssignmentOnTapHandler()
    {
        console.log(COMP_NAME +  ".ChooseAssignmentOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setIsShowChooseAssignment(true)
    } // end of ChooseAssignmentOnTapHandler

    /*===========================================
    summary: 點選 刪除單元 按鈕
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function LearningUnitDeleteOnTapHandler()
    {
        console.log(COMP_NAME +  ".LearningUnitDeleteOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        mobjChooseAssignment = null
        setUpdateChooseAssignmentTime(0)
    } // end of LearningUnitDeleteOnTapHandler

    /*===========================================
    summary: 點選 SelectAll
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function SelectAllOnTapHandler(StateIsSelectAll)
    {
        console.log(COMP_NAME +  ".SelectAllOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let blnIsSelectAll = !StateIsSelectAll
        let intIndex = 0;
        let intCount = marrStudentListData.length

        //  == 整理需要處理的變數 BEGIN ==
        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            marrStudentListData[intIndex].IsCheck = blnIsSelectAll
        }

        setIsSelectAll(blnIsSelectAll)
        setUpdateStudentDataTime(new Date().getTime())
    } // end of SelectAllOnTapHandler

    /*===========================================
    summary: 點選 學生元件
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function StudentUnitOnTapHandler(StudentIndex)
    {
        console.log(COMP_NAME +  ".StudentUnitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        marrStudentListData[StudentIndex].IsCheck = !marrStudentListData[StudentIndex].IsCheck

        // 檢查 是否為 Select All
        let intIndex = 0
        let intCount = marrStudentListData.length
        let blnIsSelectAll = true

        while ((blnIsSelectAll) && (intIndex < intCount))
        {
            if (!marrStudentListData[intIndex].IsCheck)
            {
                blnIsSelectAll = false
            }

            intIndex++
        } // end of while

        setIsSelectAll(blnIsSelectAll)
        setUpdateStudentDataTime(new Date().getTime())
    } // end of StudentUnitOnTapHandler

    /*===========================================
    summary: 點選 Submit
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function SubmitOnTapHandler()
    {
        console.log(COMP_NAME +  ".SubmitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        SubmitAssignmentData()
    } // end of SubmitOnTapHandler
    // #endregion OnTapHandler

    // #region Other Handler
    // ====== BEGIN Class下拉選單 ======
    /*===========================================
    summary: 點選 Class 選單
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ClassDropdownOnTapHandler(event, StateClassIndex)
    {
        console.log(COMP_NAME +  ".ClassDropdownOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setAnchorEl4Class(event.currentTarget)

        // 開啟 下拉選單時，滾動到 所選擇的位置      Tim20.12.11
        // 滾動位置 Index * 元件高度
        let intOffsetTop = StateClassIndex * 37
        let objMenuDom = mrefClassDropdown.current.querySelector(".MuiMenu-paper")
        objMenuDom.scroll({
            top: intOffsetTop,
            left: 0
        });
    } // end of ClassDropdownOnTapHandler

    /*===========================================
    summary: 關閉Class 下拉選單
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ClassDropdownCloseEventHandler()
    {
        console.log(COMP_NAME +  ".ClassDropdownCloseEventHandler")

        setAnchorEl4Class(null)
    } // end of ClassDropdownCloseEventHandler

    /*===========================================
    summary: 點選 Class 下拉選單 選項
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ClassItemOnTapHandler(StateClassIndex, ClassIndex)
    {
        console.log(COMP_NAME + ".ClassItemOnTapHandler: ", ClassIndex)

        if (StateClassIndex !== ClassIndex)
        {
            setIsSelectAll(false)
            setClassIndex(ClassIndex)
        }

        ClassDropdownCloseEventHandler()
    } // end of ClassItemOnTapHandler
    // ====== END Class下拉選單 ======

    /*===========================================
    summary: Message 改變 事件
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function MessageChangeHandler(e)
    {
        // console.log(COMP_NAME + ".MessageChangeHandler: e.target.value:", e.target.value)
        setMessage(e.target.value)
    } // end of MessageChangeHandler

    /*===========================================
    summary: Start Date 改變 事件
    remarks: 000 Tim 2021/11/09 Create
             001 Tim 2022/03/04 將日期文字 - 轉成 /
                                // 以台灣時間來說 +8
                                // 2022/03/03  -> 經過 new Date 會是 2022/03/03 00:00:00  
                                // 輸入的日期文字 會當作 Local Time
                                // 2022-03-03  -> 經過 new Date 會是 2022/03/03 08:00:00  
                                // 輸入的日期文字 會當作 +0 Time
    ===========================================*/
    function StartDateOnChangeEventHandler(e)
    {
        // console.log(COMP_NAME + ".StartDateOnChangeEventHandler: e.target.value:", e.target.value)
        let strStartDate = e.target.value

        // 開始時間
        let datStartLocal = new Date(strStartDate.replace(/-/g, '/'))
        datStartLocal.setHours(0, 0, 0, 0)
        console.log(COMP_NAME + ".StartDateOnChangeEventHandler datStartLocal: ", datStartLocal)

        // 截止時間
        let datDueLocal = new Date(mstrStateDueDate.replace(/-/g, '/'))
        datDueLocal.setHours(23, 59, 59, 0)
        console.log(COMP_NAME + ".StartDateOnChangeEventHandler datDueLocal: ", datDueLocal)

        setStartDate(strStartDate)

        // check 截止日期 需要大於 開始日期
        if (datDueLocal.valueOf() < datStartLocal.valueOf())
        {
            setDueDate(strStartDate)
        }
    } // end of StartDateOnChangeEventHandler

    /*===========================================
    summary: Due Date 改變 事件
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function DueDateOnChangeEventHandler(e)
    {
        // console.log(COMP_NAME + ".DueDateOnChangeEventHandler: e.target.value:", e.target.value)
        setDueDate(e.target.value)
    } // end of DueDateOnChangeEventHandler
    // #endregion Other Handler
    
    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert
    // #endregion LoadingMask and Alert Functions

    // #region ComponentCallback
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "OpenLoadingMask")
        {
            OpenLoadingMask(CallbackObj.Message)
        }
        else if (CallbackObj.Action === "CloseLoadingMask")
        {
            CloseLoadingMask()
        }
        else if (CallbackObj.Action === "ShowAlertWindow")
        {
            ShowAlert(CallbackObj.AlertObject)
        }
        else if (CallbackObj.Action === "CloseShowChooseAssignment")
        {
            setIsShowChooseAssignment(false)
        }
        else if (CallbackObj.Action === "ConfirmOnTap")
        {
            mobjChooseAssignment = {
                "LessonIndex": CallbackObj.LessonIndex,
                "LUCatSeqNo": CallbackObj.LUCatSeqNo,
                "LUName": CallbackObj.LUName,
                "SectionName": CallbackObj.SectionName,
                "SectionType": CallbackObj.SectionType
            }

            setIsShowChooseAssignment(false)
            setUpdateChooseAssignmentTime(new Date().getTime())
        }
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // #region AlertCallBack
    /*===========================================
    summary: 確認 是否 Submit AlertCallBack
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function Submit4MsgAlertCallBack (BtnObject)
    {
        console.log(COMP_NAME + ".Submit4MsgAlertCallBack: BtnObject ", BtnObject)
        if (BtnObject.index === 1) // BTN_Yes
        {
            CreateNewAssignmentByLU()
        }
        else
        {
            mobjCallParam = null;
        }
    } // end of Submit4MsgAlertCallBack

    /*===========================================
    summary: Submit成功後 要繼續Assign AlertCallBack
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function SubmitSuccess4AssignAlertCallBack (BtnObject)
    {
        console.log(COMP_NAME + ".SubmitSuccess4AssignAlertCallBack: BtnObject ", BtnObject)
        if (BtnObject.index === 1) // BTN_Yes
        {
            SubmitSuccess4AssignAfterProcess()
        }
        else
        {
            let objCallbackData = {
                "Action": "CloseShowLUAssign",
                "IsUpdate": true
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of SubmitSuccess4AssignAlertCallBack

    /*===========================================
    summary: Submit成功後 AlertCallBack
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function SubmitSuccessAlertCallBack (BtnText)
    {
        console.log(COMP_NAME + ".SubmitSuccessAlertCallBack: BtnText ", BtnText)
        
        let objCallbackData = {
            "Action": "CloseShowLUAssign",
            "IsUpdate": true
        }
        props.CallbackRef(objCallbackData)
    } // end of SubmitSuccessAlertCallBack
    // #endregion AlertCallBack

    // #region Other Functions
    /*===========================================
    summary: 取得 班級列表
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function InitClassList() 
    {
        console.log(COMP_NAME + ".InitClassList: ", window.gSession.Acc.Class)

        let intClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)

        let intIndex = 0

        window.gSession.Acc.Class.forEach((ClassData) => {
            if (parseInt(ClassData.AccountRole) === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
            {
                marrClass.push(JSON.parse(JSON.stringify(ClassData)))
                
                if (parseInt(ClassData.ClassID) === intClassID)
                {
                    mintCurrentClassIndex = intIndex
                }

                intIndex++
            } // end of if (parseInt(ClassData.AccountRole) === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        })

        setClassIndex(mintCurrentClassIndex)

        console.log(COMP_NAME + ".InitClassList END marrClass: ", marrClass)
        console.log(COMP_NAME + ".InitClassList END mintCurrentClassIndex: ", mintCurrentClassIndex)
    } // end of InitClassList

    /*===========================================
    summary: 取得 Lesson Index
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GetLessonIndex(LessonID) 
    {
        console.log(COMP_NAME + ".GetLessonIndex: ", LessonID)

        let intIndex = 0
        let intCount = window.gSession.App.BookDef[mstrBookSeqNo].Lesson.length
        let blnFound = false
        let intLessonIndex = -1

        while ((!blnFound) && (intIndex < intCount))
        {
            if (parseInt(window.gSession.App.BookDef[mstrBookSeqNo].Lesson[intIndex].ID) === parseInt(LessonID))
            {
                blnFound = true
                intLessonIndex = intIndex
                // console.log("PrefixName: ", window.gSession.App.BookDef[mstrBookSeqNo].Lesson[intIndex].PrefixName)   
            }
            intIndex++
        } // end of while

        return intLessonIndex
    } // end of GetLessonIndex

    /*===========================================
    summary: 取得 班級名稱
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GetClassName(StateClassIndex) 
    {
        let strClassName = ""

        if (
            (typeof(marrClass) !== 'undefined') &&
            (marrClass !== null) &&
            (marrClass.length > 0) &&
            (typeof(StateClassIndex) !== 'undefined') &&
            (StateClassIndex !== null) &&
            (StateClassIndex >= 0) &&
            (typeof(marrClass[StateClassIndex].ClassName) !== 'undefined') &&
            (marrClass[StateClassIndex].ClassName !== null)
            )
        {
            strClassName = marrClass[StateClassIndex].ClassName
        }

        return strClassName
    } // end of GetClassName

    /*===========================================
    summary: 初始化 班級 詳細資料
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function InitMemberData()
    {
        let intIndex = 0;
        let intCount = marrClassMemberData.length

        let objMemberItem = null
        let arrStudentData4List = []

        //  == 整理需要處理的變數 BEGIN ==
        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            objMemberItem = {
                "AccountID": marrClassMemberData[intIndex].StudentAccID,
                "Name": window.Globals.FormateDisplayName(marrClassMemberData[intIndex].FirstName, marrClassMemberData[intIndex].LastName, marrClassMemberData[intIndex].SchoolUserName),
                "IsCheck": false
            }
            arrStudentData4List.push(objMemberItem)
        }

        marrStudentListData = arrStudentData4List
        //  == 整理需要處理的變數 END ==

        console.log(COMP_NAME + ".InitMemberData marrStudentListData: ", marrStudentListData)

        setUpdateStudentDataTime(new Date().getTime())
    } // end of InitMemberData

    /*===========================================
    summary: 傳送輸入表單資料 到後端 Json格式
    remarks: 000 Tim 2020/11/09 Create
    ===========================================*/
    function SubmitAssignmentData ()
    {
        console.log(COMP_NAME + ".SubmitAssignmentData")

        let strAssignmentName = '';
        let intSectionType = 0
        let strLessonID = -1
        let intLUCatSeqNo = -1
        let datStartLocal = null    // utc輸入開始時間 檢查時間 是否小於現在時間
        let datDueLocal = null      // utc輸入截止時間 檢查時間 是否小於現在時間
        let arrStudentList = []

        let objAlertObject = null

        let objValidation = null
        let blnAlert = false
        let strAlertTitle = ""
        let strAlertMessage = ""

        // 1. Validation Message
        objValidation = ValidationMessage()
        if (!objValidation.IsValidation)
        {
            blnAlert = true
            strAlertTitle = objValidation.AlertTitle
            strAlertMessage = objValidation.AlertMessage
        }
        else
        {
            // 2. Validation Data
            objValidation = ValidationDate()
            if (!objValidation.IsValidation)
            {
                blnAlert = true
                strAlertTitle = objValidation.AlertTitle
                strAlertMessage = objValidation.AlertMessage
            }
            else
            {
                datStartLocal = objValidation.StartLocal
                datDueLocal = objValidation.DueLocal

                // 3. Validation SelectStudent
                objValidation = ValidationSelectStudent()
                if (!objValidation.IsValidation)
                {
                    blnAlert = true
                    strAlertTitle = objValidation.AlertTitle
                    strAlertMessage = objValidation.AlertMessage
                }
                else
                {
                    arrStudentList = objValidation.StudentList
                } // end of 3. Validation SelectStudent
            } // end of 2. Validation Data
        } // end of 1. Validation Message

        if (blnAlert)
        {
            objAlertObject = {
                Header: strAlertTitle,
                Body: strAlertMessage,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }

            ShowAlert(objAlertObject)
        }
        else
        {
            if (mobjChooseAssignment !== null)
            {
                intSectionType = mobjChooseAssignment.SectionType
                strLessonID = window.gSession.App.BookDef[mstrBookSeqNo].Lesson[mobjChooseAssignment.LessonIndex].ID
                intLUCatSeqNo = mobjChooseAssignment.LUCatSeqNo
            }

            // AssignmentName
            if (
                (typeof(props.SectionName) !== 'undefined') &&
                (props.SectionName !== null) &&
                (props.SectionName !== '') &&
                (typeof(props.SubSectionName) !== 'undefined') &&
                (props.SubSectionName !== null) &&
                (props.SubSectionName !== '') 
                )
            {
                console.log(COMP_NAME + ".constructor props.SectionName: ", props.SectionName)
                console.log(COMP_NAME + ".constructor props.SubSectionName: ", props.SubSectionName)
                console.log(COMP_NAME + ".constructor props.SubSubSectionName: ", props.SubSubSectionName)

                strAssignmentName = props.SectionName + ' ' + props.SubSectionName

                if (
                    (typeof(props.SubSubSectionName) !== 'undefined') &&
                    (props.SubSubSectionName !== null) &&
                    (props.SubSubSectionName !== '')
                    )
                {
                    strAssignmentName += ' - ' + props.SubSubSectionName
                }
            }
            else
            {
                strAssignmentName = window.gAppUI.LBL_Bulletin + ' ' + (new Date()).FormateBCDisplayDateTime().replace(/-/g, '/');
            }
            
            mobjCallParam = {
                "ClassID": marrClass[mintStateClassIndex].ClassID,
                "BookCategoryID": window.gSession.App.BookCatID,
                "Name": strAssignmentName,
                "Message": mstrStateMessage.trim(),
                "StartDate": datStartLocal.ToBCUTCString(),
                "DueDate": datDueLocal.ToBCUTCString(),
                "StudentList": arrStudentList,
                "SectionType": intSectionType,
                "LessonID": strLessonID,
                "LUCatSeqNo": intLUCatSeqNo,
                "AssigneeList": ""
            }

            if (mobjCallParam.StudentList.length > 0)
            {
                mobjCallParam.AssigneeList = JSON.stringify(mobjCallParam.StudentList)
            }

            console.log(COMP_NAME + ".SubmitAssignmentData mobjCallParam", mobjCallParam)

            // console.log(COMP_NAME + ".SubmitAssignmentData strLessonID", strLessonID)
            // console.log(COMP_NAME + ".SubmitAssignmentData int strLessonID", parseInt(strLessonID))
            
            if (
                (parseInt(strLessonID) !== -1) && 
                (parseInt(intLUCatSeqNo) !== -1)
                )
            {
                console.log("SubmitAssignmentData 1");
                CreateNewAssignmentByLU()
            }
            else if (
                (parseInt(strLessonID) === -1) && 
                (parseInt(intLUCatSeqNo) === -1)
                )
            {
                console.log("SubmitAssignmentData 2");

                mobjCallParam.SectionType = 3    // Announcement
                
                objAlertObject = {
                    Header: null,
                    Body: window.gAppUI.MSG_Alert_Msg_NoLessonSection4Assign,
                    CallbackRef: Submit4MsgAlertCallBack,
                    Buttons: [
                        {
                            Text: window.gAppUI.BTN_No,
                            AutoFocus: false
                        },
                        {
                            Text: window.gAppUI.BTN_Yes,
                            AutoFocus: true
                        }
                    ]
                }
                ShowAlert(objAlertObject)
            }
            else if ((parseInt(strLessonID) === -1))
            {
                console.log("SubmitAssignmentData 3");

                objAlertObject = {
                    Header: "",
                    Body: window.gAppUI.MSG_Alert_Msg_NoLesson4Assign,
                    CallbackRef: null,
                    Buttons: [
                        {
                            Text: PackageVariablesLibs.UISettings.BTN_OK,
                            AutoFocus: true
                        }
                    ]
                }
    
                ShowAlert(objAlertObject)
            }
        } 

        console.log("SubmitAssignmentData END")
    } // end of SubmitAssignmentData

    /*===========================================
    summary: 檢查 Message 格式
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function ValidationMessage() 
    {
        console.log(COMP_NAME + ".ValidationMessage")
        let objValidation = {
            "IsValidation": true,
            "AlertTitle": "",
            "AlertMessage": ""
        }

        if (mstrStateMessage.trim() === "")
        {
            objValidation.IsValidation = false
            objValidation.AlertTitle = ""
            objValidation.AlertMessage = window.gAppUI.ERR_InputAssignMessage
        }

        return objValidation
    } // end of ValidationMessage

    /*===========================================
    summary: 檢查 日期 格式
    remarks: 000 Tim 2021/11/10 Create
             001 Tim 2022/03/04 將日期文字 - 轉成 /
    ===========================================*/
    function ValidationDate() 
    {
        console.log(COMP_NAME + ".ValidationDate")
        let objValidation = {
            "IsValidation": true,
            "AlertTitle": "",
            "AlertMessage": "",
            "StartLocal": null,       // utc輸入開始時間 檢查時間 是否小於現在時間
            "DueLocal": null,         // utc輸入截止時間 檢查時間 是否小於現在時間 
        }

        let datStartLocal = null        // utc輸入開始時間 檢查時間 是否小於現在時間
        let datDueLocal = null          // utc輸入截止時間 檢查時間 是否小於現在時間
        let datNowStartLocal = null     // 目前時間-開始
        let datNowDueLocal = null       // 目前時間-截止

        // 以台灣時間來說 +8
        // 2022/03/03  -> 經過 new Date 會是 2022/03/03 00:00:00  
        // 輸入的日期文字 會當作 Local Time
        // 2022-03-03  -> 經過 new Date 會是 2022/03/03 08:00:00  
        // 輸入的日期文字 會當作 +0 Time

        // 比較日期
        // 開始時間
        datStartLocal = new Date(mstrStateStartDate.replace(/-/g, '/'))
        datStartLocal.setHours(0, 0, 0, 0)
        console.log(COMP_NAME + ".ValidationDate mstrStateStartDate: ", mstrStateStartDate)
        console.log(COMP_NAME + ".ValidationDate datStartLocal: ", datStartLocal)

        // 截止時間
        datDueLocal = new Date(mstrStateDueDate.replace(/-/g, '/'))
        datDueLocal.setHours(23, 59, 59, 0)
        console.log(COMP_NAME + ".ValidationDate datDueLocal: ", datDueLocal)

        // 目前時間-開始
        datNowStartLocal = new Date()
        datNowStartLocal.setHours(0, 0, 0, 0)

        console.log(COMP_NAME + ".ValidationDate datNowStartLocal: ", datNowStartLocal)

        // 目前時間-截止
        datNowDueLocal = new Date()
        datNowDueLocal.setHours(23, 59, 59, 0)

        // check 開始日期 需要大於 今天
        if (datStartLocal.valueOf() < datNowStartLocal.valueOf())
        {
            // ERR_StartDateEarlyToday
            objValidation.IsValidation = false
            objValidation.AlertTitle = ""
            objValidation.AlertMessage = window.gAppUI.ERR_StartDateEarlyToday
        }
        // check due date 需要大於今天
        // 如果 user select date from datepicker, datepicker should check the date-range validation
        else if (datDueLocal.valueOf() < datNowDueLocal.valueOf())
        {
            // ERR_DueDateEarlyToday
            objValidation.IsValidation = false
            objValidation.AlertTitle = ""
            objValidation.AlertMessage = window.gAppUI.ERR_DueDateEarlyToday
        }
        // check 截止日期 需要大於 開始日期
        else if (datDueLocal.valueOf() < datStartLocal.valueOf())
        {
            // ERR_DueDateEarlyStartDate
            objValidation.IsValidation = false
            objValidation.AlertTitle = ""
            objValidation.AlertMessage = window.gAppUI.ERR_DueDateEarlyStartDate
        }
        else
        {
            objValidation.StartLocal = datStartLocal
            objValidation.DueLocal = datDueLocal
        }

        return objValidation
    } // end of ValidationDate

    /*===========================================
    summary: 檢查 Message 格式
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function ValidationSelectStudent() 
    {
        console.log(COMP_NAME + ".ValidationSelectStudent")
        let objValidation = {
            "IsValidation": true,
            "AlertTitle": "",
            "AlertMessage": "",
            "StudentList": []
        }

        let intIndex4Student = 0
        let intCount4Student = marrStudentListData.length
        let arrStudentList = []

        // 取得學生選擇資料
        for (intIndex4Student = 0; intIndex4Student < intCount4Student; intIndex4Student++)
        {
            if (marrStudentListData[intIndex4Student].IsCheck)
            {
                arrStudentList.push(parseInt(marrStudentListData[intIndex4Student].AccountID))
            }
        } // end of for (intIndex4Student = 0;

        if (arrStudentList.length === 0)
        {
            // ERR_AssignValidationStudentList        
            objValidation.IsValidation = false
            objValidation.AlertTitle = ""
            objValidation.AlertMessage = window.gAppUI.ERR_AssignValidationStudentList
        }
        else
        {
            objValidation.StudentList = arrStudentList
        }

        return objValidation
    } // end of ValidationSelectStudent

    /*===========================================
    summary: 檢查 是否有其他班級
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function CheckClassCount ()
    {
        console.log(COMP_NAME + ".CheckClassCount")

        let intClassCount = 0
        let intIndex = 0
        let intCount = marrClass.length

        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            if (parseInt(marrClass[intIndex].AccountRole) === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
            {
                intClassCount++
            }
        }

        console.log(COMP_NAME + ".CheckClassCount intClassCount: ", intClassCount)

        let blnIsHave = false
        if (intClassCount >= 2)
        {
            blnIsHave = true
        }

        return blnIsHave
    } // end of CheckClassCount

    /*===========================================
    summary: Submit成功後 要繼續Assign 後續流程
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function SubmitSuccess4AssignAfterProcess ()
    {
        console.log(COMP_NAME + ".SubmitSuccess4AssignAfterProcess");

        SetNextClass()
    } // end of SubmitSuccess4AssignAfterProcess

    /*===========================================
    summary: 設定 下一個 Class
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function SetNextClass ()
    {
        console.log(COMP_NAME + ".SetNextClass")

        let intClassIndex = 0
        let intIndex = mintStateClassIndex + 1
        let intCount = marrClass.length
        let blnFound = false

        while ((!blnFound) && (intIndex < intCount))
        {
            if (parseInt(marrClass[intIndex].AccountRole) === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
            {
                intClassIndex = intIndex
                blnFound = true
            }
            intIndex++
        } // end of while

        if (!blnFound)
        {
            intIndex = 0
            while ((!blnFound) && (intIndex < intCount))
            {
                if (parseInt(marrClass[intIndex].AccountRole) === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
                {
                    intClassIndex = intIndex
                    blnFound = true
                }
                intIndex++
            } // end of while
        }

        if (mintStateClassIndex !== intClassIndex)
        {
            setIsSelectAll(false)
            setClassIndex(intClassIndex)
        }
    } // end of SetNextClass
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 班級元件 Cls
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GetClassUnitCls(StateClassIndex, ClassIndex) 
    {
        let objCls = cssLUAssign.divClassUnit

        if (StateClassIndex === ClassIndex)
        {
            objCls = cssLUAssign.divClassUnitSelected
        }

        return objCls
    } // end of GetClassUnitCls

    /*===========================================
    summary: 取得 選擇全部學生 Cls
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GetSelectAllIconCls(StateIsSelectAll) 
    {
        let objCls = cssLUAssign.divSelectAllIcon

        if (StateIsSelectAll)
        {
            objCls = cssLUAssign.divSelectAllSelectedIcon
        }

        return objCls
    } // end of GetSelectAllIconCls

    /*===========================================
    summary: 取得 學生元件 Cls
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function GetStudentUnitCls(IsCheck) 
    {
        let objCls = cssLUAssign.divStudentUnit

        if (IsCheck)
        {
            objCls = cssLUAssign.divStudentUnitSelected
        }

        return objCls
    } // end of GetStudentUnitCls

    /*===========================================
    summary: 取得 學生元件 Check圖示 Cls
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function GetStudentUnitCheckCls(IsCheck) 
    {
        let objCls = cssLUAssign.divStudentUnitCheckIcon

        if (IsCheck)
        {
            objCls = cssLUAssign.divStudentUnitCheckSelectedIcon
        }

        return objCls
    } // end of GetStudentUnitCheckCls

    /*===========================================
    summary: 取得 學生元件 Check圖示 Cls
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function GetStudentUnitNameCls(IsCheck) 
    {
        let objCls = cssLUAssign.divStudentUnitName

        if (IsCheck)
        {
            objCls = cssLUAssign.divStudentUnitNameSelected
        }

        return objCls
    } // end of GetStudentUnitNameCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 建立 新版 考卷後 的 流程
    remarks: 000 Tim 2020/12/01 Create
    ===========================================*/
    function CreateNewAssignmentByLUAfterProcess ()
    {   
        console.log(COMP_NAME + ".CreateNewAssignmentByLUAfterProcess")

        let objAlertObject = null

        if (CheckClassCount())
        {
            objAlertObject = {
                Header: null,
                Body: window.gAppUI.MSG_SubmitSuccess4Assign,
                CallbackRef: SubmitSuccess4AssignAlertCallBack,
                Buttons: [{
                    Text: window.gAppUI.BTN_No,
                    AutoFocus: false
                },
                {
                    Text: window.gAppUI.BTN_Yes,
                    AutoFocus: true
                }]
            }
        }
        else
        {
            objAlertObject = {
                Header: null,
                Body: window.gAppUI.MSG_SubmitSuccess,
                CallbackRef: SubmitSuccessAlertCallBack,
                Buttons: [{
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }]
            }
        }

        ShowAlert(objAlertObject)

        mobjCallParam = null
    } // end of CreateNewAssignmentByLUAfterProcess

    /*===========================================
    summary: 取得 MemberDataList 資料後 的 流程
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GetClassMemberDataListAfterProcess (ReturnData)
    {   
        console.log(COMP_NAME + ".GetClassMemberDataListAfterProcess")

        marrClassMemberData = ReturnData

        console.log("GetClassMemberDataListAfterProcess: marrClassMemberData: ", marrClassMemberData)

        InitMemberData()
    } // end of GetClassMemberDataListAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 取得 班級學生列表
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GetClassMemberDataList ()
    {
        console.log(COMP_NAME + ".GetClassMemberDataList")

        let objRetryFuncRef = GetClassMemberDataList
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetClassMemberDataListCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetClassMemberDataList)

            let objCallData = {
                "Func": "GetClassMemberDataList",
                "ClassID": mobjCallParam.ClassID,
                "DataType": mobjCallParam.DataType
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetClassMemberDataList

    /*===========================================
    summary: 取得 班級學生列表 Callback
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GetClassMemberDataListCallback (Return)
    {
        console.log(COMP_NAME + ".GetClassMemberDataListCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetClassMemberDataList_No
        let strErrorTitle = window.gAppUI.ERR_GetClassMemberDataList_Title
        let strErrMsg = window.gAppUI.ERR_GetClassMemberDataList_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break;
            }

            console.log("GetClassMemberDataListCallback: ErrNo: ", Return.ErrNo);
            console.log("GetClassMemberDataListCallback: CalledErrNo: ", Return.CalledErrNo);
        }
        else
        {
            console.log("GetClassMemberDataListCallback Return.Data: ", Return.Data);

            GetClassMemberDataListAfterProcess(Return.Data)
        }
    } // end of GetClassMemberDataListCallback

    /*===========================================
    summary: 建立 新版 考卷
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function CreateNewAssignmentByLU ()
    {
        console.log(COMP_NAME + ".CreateNewAssignmentByLU")

        let objRetryFuncRef = CreateNewAssignmentByLU
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = CreateNewAssignmentByLUCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_CreateNewAssignmentByLU)

            let objCallData = {
                "Func": "CreateNewAssignmentByLU",
                "ClassID": mobjCallParam.ClassID,
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "LUCatSeqNo": mobjCallParam.LUCatSeqNo,
                "AssignName": mobjCallParam.Name,
                "Message": mobjCallParam.Message,
                "StartDate": mobjCallParam.StartDate,
                "DueDate": mobjCallParam.DueDate,
                "SectionType": mobjCallParam.SectionType,
                "AssigneeList": mobjCallParam.AssigneeList
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of CreateNewAssignmentByLU

    /*===========================================
    summary: 建立 新版 考卷 Callback
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function CreateNewAssignmentByLUCallback (Return)
    {
        console.log(COMP_NAME + ".CreateNewAssignmentByLUCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_CreateNewAssignmentByLU_No
        let strErrorTitle = window.gAppUI.ERR_CreateNewAssignmentByLU_Title
        let strErrMsg = window.gAppUI.ERR_CreateNewAssignmentByLU_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break;
            }

            console.log("CreateNewAssignmentByLUCallback: ErrNo: ", Return.ErrNo);
            console.log("CreateNewAssignmentByLUCallback: CalledErrNo: ", Return.CalledErrNo);
        }
        else
        {
            console.log("CreateNewAssignmentByLUCallback Return.Data: ", Return.Data);

            CreateNewAssignmentByLUAfterProcess()
        }
    } // end of CreateNewAssignmentByLUCallback
    // #endregion Web Service

    // #region Render元件
    /*===========================================
    summary: Submit Button 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentStudentUnitContent( {StudentData} )
    {        
        return (
            <>
                <div className={GetStudentUnitCheckCls(StudentData.IsCheck)}/>
                <div className={GetStudentUnitNameCls(StudentData.IsCheck)}>
                    {StudentData.Name}
                </div>
            </>
        )
    } // end of ComponentStudentUnitContent

    /*===========================================
    summary: Submit Button 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentSubmitButton()
    {        
        return (
            <div className={cssLUAssign.btnSubmit} onClick={() => SubmitOnTapHandler()}>
                {window.gAppUI.BTN_Submit}
            </div>
        )
    } // end of ComponentSubmitButton

    /*===========================================
    summary: Select All Button 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentSelectAllButton( {StateIsSelectAll} )
    {        
        return (
            <div className={cssLUAssign.btnSelectAll} onClick={() => SelectAllOnTapHandler(StateIsSelectAll)}>
                <div className={GetSelectAllIconCls(StateIsSelectAll)}/>
                <div className={cssLUAssign.divSelectAllText}>
                    {window.gAppUI.LBL_SelectAll}
                </div>
            </div>
        )
    } // end of ComponentSelectAllButton

    /*===========================================
    summary: Class Content 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentClassContent( {StateClassIndex} )
    {        
        let strClassName = GetClassName(StateClassIndex)
        return (
            <>
                <div className={cssLUAssign.btnClassIcon}/>
                <div className={cssLUAssign.divClassText}>
                    {strClassName}
                </div>
                <div className={cssLUAssign.divClassDropdownIcon}/>
            </>
        )
    } // end of ComponentClassContent

    /*===========================================
    summary: Date Separator 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentDateSeparator()
    {        
        return (
            <div className={cssLUAssign.divSeparator}>
                ............
            </div>
        )
    } // end of ComponentDateSeparator 

    /*===========================================
    summary: Date Title 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentDateTitle( {Title} ) 
    {        
        return (
            <div className={cssLUAssign.divDateTitleRow}>
                <div className={cssLUAssign.divDateIcon}/>
                <div className={cssLUAssign.divDateTitle}>
                    {Title}
                </div>
            </div>
        )
    } // end of ComponentDateTitle 

    /*===========================================
    summary: Choose Assignment 未選擇 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentChooseAssignmentNoChoose() 
    {        
        return (
            <div className={cssLUAssign.divChooseAssignment}>
                <div className={cssLUAssign.btnChooseAssignment} onClick={() => ChooseAssignmentOnTapHandler()}>
                    <div className={cssLUAssign.btnChooseIcon}/>
                    <div className={cssLUAssign.divChooseText}>
                        {window.gAppUI.LBL_ChooseAssignment}
                    </div>
                </div>
            </div>
        )
    } // end of ComponentChooseAssignmentNoChoose 

    /*===========================================
    summary: Choose Assignment 已選擇 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentChooseAssignmentChosen( {PrefixName, SectionName, LUName} ) 
    {        
        let strLearningUnitText = PrefixName + " - " + SectionName + " " + LUName

        return(
            <div className={cssLUAssign.divChooseAssignment}>
                <div className={cssLUAssign.divLearningUnit}>
                    <div className={cssLUAssign.divLearningUnitText}>
                        {strLearningUnitText}
                    </div>
                    <div className={cssLUAssign.divLearningUnitDeleteIcon} onClick={() => LearningUnitDeleteOnTapHandler()}/>
                </div>

                <div className={cssLUAssign.btnChooseAssignmentSelected} onClick={() => ChooseAssignmentOnTapHandler()}>
                    <div className={cssLUAssign.btnChooseIcon}/>
                </div>
            </div>
        )  
    } // end of ComponentChooseAssignmentChosen

    /*===========================================
    summary: Message Title 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentMessageTitle() 
    {        
        return (
            <div className={cssLUAssign.divMessageTitle}>
                {window.gAppUI.LBL_Message}
            </div>
        )
    } // end of ComponentMessageTitle

    /*===========================================
    summary: Top Tool 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentTopTool() 
    {        
        return (
            <div className={cssLUAssign.divTopTool}>
                <div className={cssLUAssign.btnBack} onClick={() => BackOnTapHandler()}/>
                <div className={cssLUAssign.divTitle}>
                    {window.gAppUI.LBL_Bulletin}
                </div>
            </div>
        )
    } // end of ComponentTopTool
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 選擇 Assignment單元 視窗 的顯示
    remarks: 000 Tim 2021/11/10 Create
    ===========================================*/
    function RenderChooseAssignmentWindowsWrapper(StateIsShowChooseAssignment)
    {
        if (StateIsShowChooseAssignment)
        {
            let intLessonIndex = -1
            let intSectionType = -1
            let intLUCatSeqNo = -1

            if (mobjChooseAssignment !== null)
            {
                intLessonIndex = mobjChooseAssignment.LessonIndex
                intSectionType = mobjChooseAssignment.SectionType
                intLUCatSeqNo = mobjChooseAssignment.LUCatSeqNo
            }
            
            return(
                <ChooseAssignment LessonIndex={intLessonIndex} 
                    SectionType={intSectionType}
                    LUCatSeqNo={intLUCatSeqNo} 
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderChooseAssignmentWindowsWrapper

    /*===========================================
    summary: Render 學生列表
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function RenderStudentListWrapper(StateUpdateStudentDataTime)
    {
        if (StateUpdateStudentDataTime > 0)
        {
            return(
                <div className={cssLUAssign.divStudentArea}>
                    {marrStudentListData.map((StudentData, StudentIndex) =>
                        <div key={StudentIndex} className={GetStudentUnitCls(StudentData.IsCheck)} 
                                onClick={() => StudentUnitOnTapHandler(StudentIndex)}>
                            <ComponentStudentUnitContent StudentData={StudentData} />
                        </div>
                    )}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderStudentListWrapper

    /*===========================================
    summary: Render Class 下拉 選單 選項
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function RenderClassMenuListWrapper(StateClassIndex)
    {
        return(
            <div>
                {marrClass.map((ClassData, ClassIndex) =>
                    <MenuItem key={ClassIndex} className={GetClassUnitCls(StateClassIndex, ClassIndex)} onClick={() => ClassItemOnTapHandler(StateClassIndex, ClassIndex)}>
                        {ClassData.ClassName}
                    </MenuItem>
                )}
            </div>
        )
    } // end of RenderClassMenuListWrapper

    /*===========================================
    summary: Render 選擇 作業 選項
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function RenderClassSelectWrapper(StateClassIndex)
    {
        return(
            <div className={cssLUAssign.divClass}>
                <div className={cssLUAssign.btnClass} aria-controls="menuClass"
                        onClick={(event) => ClassDropdownOnTapHandler(event, StateClassIndex)}>
                    <ComponentClassContent StateClassIndex={StateClassIndex} />
                </div> 

                <Menu id="menuClass" ref={mrefClassDropdown} 
                    anchorEl={anchorEl4Class} keepMounted 
                    open={(anchorEl4Class === null) ? false : true}
                    onClose={() => ClassDropdownCloseEventHandler()}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center'
                    }}
                    className={cssLUAssign.menuClass}
                >
                    {RenderClassMenuListWrapper(StateClassIndex)}
                </Menu>
            </div> 
        )
    } // end of RenderClassSelectWrapper

    /*===========================================
    summary: Render Due Date Area 日期選單
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function RenderDueDateAreaWrapper()
    {
        let strTextFieldID = "txtDueDate"
        if (window.gSession.App.InApp)
        {
            strTextFieldID = "txtDueDateApp"
        }

        return(
            <div className={cssLUAssign.divDateMain}>
                <ComponentDateTitle Title={window.gAppUI.LBL_DueDate} />
                
                <div className={cssLUAssign.btnDate}>
                    <TextField id={strTextFieldID} 
                        type="date" value={dueDate}
                        onChange={(event) => DueDateOnChangeEventHandler(event)}/>
                </div>
            </div>
        )
    } // end of RenderDueDateAreaWrapper

    /*===========================================
    summary: Render Start Date Area 日期選單
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function RenderStartDateAreaWrapper()
    {
        let strTextFieldID = "txtStartDate"
        if (window.gSession.App.InApp)
        {
            strTextFieldID = "txtStartDateApp"
        }

        return(
            <div className={cssLUAssign.divDateMain}>
                <ComponentDateTitle Title={window.gAppUI.LBL_StartDate} />
                
                <div className={cssLUAssign.btnDate}>
                    <TextField id={strTextFieldID} 
                        type="date" value={startDate}
                        onChange={(event) => StartDateOnChangeEventHandler(event)}/>
                </div>
            </div>
        )
    } // end of RenderStartDateAreaWrapper

    /*===========================================
    summary: Render DateArea
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function RenderDateAreaWrapper()
    {
        return(
            <div className={cssLUAssign.divDateAreaMain}>
                {RenderStartDateAreaWrapper()}

                <ComponentDateSeparator />

                {RenderDueDateAreaWrapper()}
            </div>
        )
    } // end of RenderDateAreaWrapper

    /*===========================================
    summary: Render 選擇 作業 選項
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function RenderChooseAssignmentWrapper(StateUpdateChooseAssignmentTime)
    {
        if (
            (StateUpdateChooseAssignmentTime > 0) &&
            (mobjChooseAssignment !== null)
            )
        {
            return(
                <ComponentChooseAssignmentChosen PrefixName={window.gSession.App.BookDef[mstrBookSeqNo].Lesson[mobjChooseAssignment.LessonIndex].PrefixName} SectionName={mobjChooseAssignment.SectionName} LUName={mobjChooseAssignment.LUName}/>
            )
        }
        else
        {
            return(
                <ComponentChooseAssignmentNoChoose />
            )
        }
    } // end of RenderChooseAssignmentWrapper

    /*===========================================
    summary: Render Bottom Content Area 的顯示
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function RenderBottomContentAreaWrapper()
    {
        return (
            <div className={cssLUAssign.divBottomContentArea}>
                {RenderChooseAssignmentWrapper(updateChooseAssignmentTime)} 

                <div className={cssLUAssign.divChooseLine}/>

                {RenderDateAreaWrapper()}

                <div className={cssLUAssign.divDateLine}/>

                {RenderClassSelectWrapper(classIndex)}

                <ComponentSelectAllButton StateIsSelectAll={isSelectAll} />

                {RenderStudentListWrapper(updateStudentDataTime)}

                <ComponentSubmitButton />
            </div>
        )
    } // end of RenderBottomContentAreaWrapper

    /*===========================================
    summary: Render Message Area 的顯示
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function RenderMessageAreaWrapper()
    {
        return (
            <div className={cssLUAssign.divMessageArea}>
                <ComponentMessageTitle />

                <label htmlFor="textareaMessage" className={cssLUAssign.divHidden}>
                    {window.gAppUI.LBL_Message}
                </label>
                <textarea id="textareaMessage"
                    className={cssLUAssign.txtMessage} 
                    value={message}
                    placeholder={window.gAppUI.LBL_AssignMessagePlaceHolder} 
                    maxLength={MAX_MESSAGE_CHARACHERS}
                    onChange={(event) => MessageChangeHandler(event)}
                />
            </div>
        )
    } // end of RenderMessageAreaWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <>
                {RenderMessageAreaWrapper()}
                {RenderBottomContentAreaWrapper()}
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <>
                <div className={cssLUAssign.divBG}>
                    <ComponentTopTool/>
                    
                    {RenderContentWrapper()}

                    {RenderChooseAssignmentWindowsWrapper(isShowChooseAssignment)}
                </div>
                
                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
            </>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default LUAssign